import { z } from 'zod'

export type ResGetCaseAlertListQuery = ResCaseAlertItem[]

export type ReqUpsertCaseAlertMutation = ReqCaseAlertItem[]

export type CaseAlertTimeUnit = 'day' | 'week' | 'month'

export interface ResUpsertCaseAlertMutation {
  failedCount: number
  successCount: number
  successList: ResCaseAlertItem[]
}

export interface ReqDeleteCaseAlertMutation {
  ids: number[]
}

export interface ReqCaseAlertItem {
  id?: number
  alertType: string
  caseId: number
  deadline: string
  timeAgo: number
  timeUnit: string
}

export const ResCaseAlertItemSchema = z.object({
  id: z.number(),
  alertType: z.string(),
  caseId: z.number(),
  /**
   * YYYY-MM-DDTHH:mm:ssZ
   */
  deadline: z.string(),
  /**
   * YYYY-MM-DDTHH:mm:ssZ
   */
  notificationTime: z.string(),
  timeAgo: z.number(),
  timeUnit: z.enum(['day', 'week', 'month']),
})
export type ResCaseAlertItem = z.infer<typeof ResCaseAlertItemSchema>
